import React from 'react'
import styled from 'styled-components'
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
} from '@mui/material'

import { ANPRHitType } from '../types'

interface Props {
    hits: ANPRHitType[]
}

const S = {
    Header: styled.div`
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
    `,
}

const ANPRSection: React.FC<Props> = ({ hits }) => {
    return (
        <Paper sx={{ p: 2 }}>
            <S.Header>
                <Typography variant="h5">ANPR</Typography>
                <Chip label="HIT" color="error" size="small" />
            </S.Header>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Camera Location</TableCell>
                            <TableCell>Direction</TableCell>
                            <TableCell>Country</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {hits.map((hit, i) => (
                            <TableRow key={i}>
                                <TableCell>
                                    {new Date(hit.sightingDate).toLocaleString()}
                                </TableCell>
                                <TableCell>{hit.cameraLocation}</TableCell>
                                <TableCell>{hit.direction}</TableCell>
                                <TableCell>{hit.country}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default ANPRSection
